interface MasqueradeBannerProps {
  masquerading?: string
}

export const MasqueradeBanner = ({ masquerading }: MasqueradeBannerProps) => {
  if (!masquerading) return null

  return (
    <div className="w-full border-b border-[#c76a10] bg-[#fff2d8] text-[#5c2d0a]">
      <div className="mx-auto flex max-w-[1400px] items-start gap-3 px-6 py-3 text-sm md:text-base">
        <i className="fa-solid fa-user-secret mt-0.5" aria-hidden="true" />
        <p>
          <span className="font-semibold">Masquerade session active.</span> You
          are viewing this portal as a member on behalf of{' '}
          <span className="font-medium">{masquerading}</span>.
        </p>
      </div>
    </div>
  )
}

export default MasqueradeBanner
